module.exports = __webpack_public_path__ + "img/icon2.4609f8a7.png";